import React from 'react';

const VehicleIcon = ({ type, selected = false }) => {
  const mainColor = selected ? '#1db584' : '#FF8C42';
  const darkColor = selected ? '#16a075' : '#E67E38';
  const accentColor = selected ? '#0f7a5f' : '#CC6A2E';
  
  const icons = {
    carrosserie: (
      <svg width="64" height="64" viewBox="0 0 80 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Cabine */}
        <rect x="8" y="22" width="16" height="18" rx="2" fill={mainColor}/>
        <rect x="10" y="24" width="5" height="8" rx="1" fill="#ffffff" opacity="0.7"/>
        <rect x="17" y="24" width="5" height="8" rx="1" fill="#ffffff" opacity="0.7"/>
        
        {/* Caisse fermée */}
        <rect x="26" y="18" width="40" height="22" rx="2" fill={mainColor}/>
        <rect x="28" y="20" width="36" height="18" fill={darkColor}/>
        <line x1="32" y1="20" x2="32" y2="38" stroke={accentColor} strokeWidth="1"/>
        <line x1="40" y1="20" x2="40" y2="38" stroke={accentColor} strokeWidth="1"/>
        <line x1="48" y1="20" x2="48" y2="38" stroke={accentColor} strokeWidth="1"/>
        <line x1="56" y1="20" x2="56" y2="38" stroke={accentColor} strokeWidth="1"/>
        
        {/* Châssis */}
        <rect x="8" y="40" width="58" height="2" fill={accentColor}/>
        
        {/* Roues */}
        <circle cx="18" cy="46" r="6" fill="#2D3748"/>
        <circle cx="18" cy="46" r="4" fill="#4A5568"/>
        <circle cx="56" cy="46" r="6" fill="#2D3748"/>
        <circle cx="56" cy="46" r="4" fill="#4A5568"/>
      </svg>
    ),
    fourgon: (
      <svg width="64" height="64" viewBox="0 0 80 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Cabine */}
        <rect x="8" y="20" width="16" height="20" rx="2" fill={mainColor}/>
        <rect x="10" y="22" width="5" height="8" rx="1" fill="#ffffff" opacity="0.7"/>
        <rect x="17" y="22" width="5" height="8" rx="1" fill="#ffffff" opacity="0.7"/>
        
        {/* Fourgon */}
        <rect x="26" y="16" width="40" height="24" rx="2" fill={mainColor}/>
        <rect x="28" y="18" width="36" height="20" fill={darkColor}/>
        
        {/* Fenêtres latérales */}
        <rect x="32" y="22" width="8" height="6" rx="1" fill="#ffffff" opacity="0.6"/>
        <rect x="42" y="22" width="8" height="6" rx="1" fill="#ffffff" opacity="0.6"/>
        <rect x="52" y="22" width="8" height="6" rx="1" fill="#ffffff" opacity="0.6"/>
        
        {/* Porte arrière */}
        <line x1="62" y1="18" x2="62" y2="38" stroke={accentColor} strokeWidth="2"/>
        
        {/* Châssis */}
        <rect x="8" y="40" width="58" height="2" fill={accentColor}/>
        
        {/* Roues */}
        <circle cx="18" cy="46" r="6" fill="#2D3748"/>
        <circle cx="18" cy="46" r="4" fill="#4A5568"/>
        <circle cx="56" cy="46" r="6" fill="#2D3748"/>
        <circle cx="56" cy="46" r="4" fill="#4A5568"/>
      </svg>
    ),
    fourgon_frigo: (
      <svg width="64" height="64" viewBox="0 0 80 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Cabine */}
        <rect x="8" y="20" width="16" height="20" rx="2" fill={mainColor}/>
        <rect x="10" y="22" width="5" height="8" rx="1" fill="#ffffff" opacity="0.7"/>
        <rect x="17" y="22" width="5" height="8" rx="1" fill="#ffffff" opacity="0.7"/>
        
        {/* Fourgon frigo */}
        <rect x="26" y="16" width="40" height="24" rx="2" fill={mainColor}/>
        <rect x="28" y="18" width="36" height="20" fill={darkColor}/>
        
        {/* Symbole froid */}
        <path d="M46 24 L46 30 M43 27 L49 27" stroke="#60A5FA" strokeWidth="2" strokeLinecap="round"/>
        <path d="M44 25 L48 29 M48 25 L44 29" stroke="#60A5FA" strokeWidth="1.5" strokeLinecap="round"/>
        
        {/* Unité de réfrigération */}
        <rect x="58" y="14" width="6" height="6" rx="1" fill="#3B82F6"/>
        <line x1="59" y1="16" x2="63" y2="16" stroke="#ffffff" strokeWidth="1"/>
        <line x1="59" y1="18" x2="63" y2="18" stroke="#ffffff" strokeWidth="1"/>
        
        {/* Châssis */}
        <rect x="8" y="40" width="58" height="2" fill={accentColor}/>
        
        {/* Roues */}
        <circle cx="18" cy="46" r="6" fill="#2D3748"/>
        <circle cx="18" cy="46" r="4" fill="#4A5568"/>
        <circle cx="56" cy="46" r="6" fill="#2D3748"/>
        <circle cx="56" cy="46" r="4" fill="#4A5568"/>
      </svg>
    ),
    plateau: (
      <svg width="64" height="64" viewBox="0 0 80 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Cabine */}
        <rect x="8" y="24" width="16" height="18" rx="2" fill={mainColor}/>
        <rect x="10" y="26" width="5" height="8" rx="1" fill="#ffffff" opacity="0.7"/>
        <rect x="17" y="26" width="5" height="8" rx="1" fill="#ffffff" opacity="0.7"/>
        
        {/* Plateau plat */}
        <rect x="26" y="30" width="40" height="12" rx="1" fill={mainColor}/>
        <rect x="26" y="32" width="40" height="8" fill={darkColor}/>
        
        {/* Barres de sécurité */}
        <line x1="28" y1="26" x2="28" y2="32" stroke={accentColor} strokeWidth="2"/>
        <line x1="36" y1="26" x2="36" y2="32" stroke={accentColor} strokeWidth="2"/>
        <line x1="44" y1="26" x2="44" y2="32" stroke={accentColor} strokeWidth="2"/>
        <line x1="52" y1="26" x2="52" y2="32" stroke={accentColor} strokeWidth="2"/>
        <line x1="60" y1="26" x2="60" y2="32" stroke={accentColor} strokeWidth="2"/>
        
        {/* Châssis */}
        <rect x="8" y="42" width="58" height="2" fill={accentColor}/>
        
        {/* Roues */}
        <circle cx="18" cy="48" r="6" fill="#2D3748"/>
        <circle cx="18" cy="48" r="4" fill="#4A5568"/>
        <circle cx="56" cy="48" r="6" fill="#2D3748"/>
        <circle cx="56" cy="48" r="4" fill="#4A5568"/>
      </svg>
    ),
    porte_char: (
      <svg width="64" height="64" viewBox="0 0 80 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Tracteur */}
        <rect x="8" y="26" width="16" height="16" rx="2" fill={mainColor}/>
        <rect x="10" y="28" width="5" height="8" rx="1" fill="#ffffff" opacity="0.7"/>
        <rect x="17" y="28" width="5" height="8" rx="1" fill="#ffffff" opacity="0.7"/>
        
        {/* Sellette */}
        <path d="M24 32 L30 32 L32 34 L30 36 L24 36 Z" fill={accentColor}/>
        
        {/* Remorque porte-char (basse) */}
        <path d="M30 34 L68 34 L68 38 L30 38 Z" fill={mainColor}/>
        <rect x="32" y="32" width="34" height="6" fill={darkColor}/>
        
        {/* Rampes */}
        <path d="M66 32 L72 28" stroke={accentColor} strokeWidth="2" strokeLinecap="round"/>
        <path d="M66 38 L72 42" stroke={accentColor} strokeWidth="2" strokeLinecap="round"/>
        
        {/* Châssis */}
        <rect x="8" y="42" width="60" height="2" fill={accentColor}/>
        
        {/* Roues */}
        <circle cx="16" cy="48" r="6" fill="#2D3748"/>
        <circle cx="16" cy="48" r="4" fill="#4A5568"/>
        <circle cx="38" cy="48" r="5" fill="#2D3748"/>
        <circle cx="38" cy="48" r="3" fill="#4A5568"/>
        <circle cx="46" cy="48" r="5" fill="#2D3748"/>
        <circle cx="46" cy="48" r="3" fill="#4A5568"/>
        <circle cx="60" cy="48" r="5" fill="#2D3748"/>
        <circle cx="60" cy="48" r="3" fill="#4A5568"/>
      </svg>
    ),
    camion_benne: (
      <svg width="64" height="64" viewBox="0 0 80 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Cabine */}
        <rect x="8" y="26" width="16" height="18" rx="2" fill={mainColor}/>
        <rect x="10" y="28" width="5" height="8" rx="1" fill="#ffffff" opacity="0.7"/>
        <rect x="17" y="28" width="5" height="8" rx="1" fill="#ffffff" opacity="0.7"/>
        
        {/* Benne basculante */}
        <path d="M26 20 L28 12 L66 12 L68 20 L68 36 L26 36 Z" fill={mainColor}/>
        <rect x="28" y="14" width="38" height="20" fill={darkColor}/>
        
        {/* Lignes de renfort */}
        <line x1="32" y1="14" x2="30" y2="34" stroke={accentColor} strokeWidth="1.5"/>
        <line x1="40" y1="14" x2="38" y2="34" stroke={accentColor} strokeWidth="1.5"/>
        <line x1="48" y1="14" x2="46" y2="34" stroke={accentColor} strokeWidth="1.5"/>
        <line x1="56" y1="14" x2="54" y2="34" stroke={accentColor} strokeWidth="1.5"/>
        <line x1="64" y1="14" x2="62" y2="34" stroke={accentColor} strokeWidth="1.5"/>
        
        {/* Verin hydraulique */}
        <line x1="26" y1="36" x2="32" y2="20" stroke="#CBD5E0" strokeWidth="3"/>
        
        {/* Châssis */}
        <rect x="8" y="44" width="60" height="2" fill={accentColor}/>
        
        {/* Roues */}
        <circle cx="18" cy="50" r="6" fill="#2D3748"/>
        <circle cx="18" cy="50" r="4" fill="#4A5568"/>
        <circle cx="52" cy="50" r="6" fill="#2D3748"/>
        <circle cx="52" cy="50" r="4" fill="#4A5568"/>
        <circle cx="60" cy="50" r="6" fill="#2D3748"/>
        <circle cx="60" cy="50" r="4" fill="#4A5568"/>
      </svg>
    ),
    porte_engins: (
      <svg width="64" height="64" viewBox="0 0 80 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Tracteur */}
        <rect x="8" y="28" width="16" height="16" rx="2" fill={mainColor}/>
        <rect x="10" y="30" width="5" height="8" rx="1" fill="#ffffff" opacity="0.7"/>
        <rect x="17" y="30" width="5" height="8" rx="1" fill="#ffffff" opacity="0.7"/>
        
        {/* Sellette */}
        <path d="M24 34 L30 34 L32 36 L30 38 L24 38 Z" fill={accentColor}/>
        
        {/* Remorque porte-engins */}
        <rect x="30" y="28" width="38" height="16" rx="2" fill={mainColor}/>
        <rect x="32" y="30" width="34" height="12" fill={darkColor}/>
        
        {/* Engin chargé (grue/pelle) */}
        <rect x="42" y="24" width="12" height="8" rx="1" fill="#F59E0B"/>
        <rect x="46" y="20" width="4" height="4" fill="#FBBF24"/>
        <path d="M48 20 L52 16" stroke="#FBBF24" strokeWidth="2" strokeLinecap="round"/>
        
        {/* Rampes */}
        <rect x="66" y="40" width="6" height="4" rx="1" fill={accentColor}/>
        
        {/* Châssis */}
        <rect x="8" y="44" width="60" height="2" fill={accentColor}/>
        
        {/* Roues */}
        <circle cx="16" cy="50" r="6" fill="#2D3748"/>
        <circle cx="16" cy="50" r="4" fill="#4A5568"/>
        <circle cx="40" cy="50" r="5" fill="#2D3748"/>
        <circle cx="40" cy="50" r="3" fill="#4A5568"/>
        <circle cx="48" cy="50" r="5" fill="#2D3748"/>
        <circle cx="48" cy="50" r="3" fill="#4A5568"/>
        <circle cx="60" cy="50" r="5" fill="#2D3748"/>
        <circle cx="60" cy="50" r="3" fill="#4A5568"/>
      </svg>
    ),
    autre: (
      <svg width="64" height="64" viewBox="0 0 80 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Camion générique simplifié */}
        <rect x="12" y="24" width="14" height="16" rx="2" fill={mainColor} opacity="0.4"/>
        <rect x="28" y="20" width="32" height="20" rx="2" fill={mainColor} opacity="0.4"/>
        
        {/* Symbole + */}
        <circle cx="44" cy="30" r="14" stroke={mainColor} strokeWidth="2" fill="none" strokeDasharray="4 3"/>
        <path d="M44 20 V40 M34 30 H54" stroke={mainColor} strokeWidth="3" strokeLinecap="round"/>
        
        {/* Roues */}
        <circle cx="20" cy="46" r="5" fill="#4A5568" opacity="0.5"/>
        <circle cx="52" cy="46" r="5" fill="#4A5568" opacity="0.5"/>
      </svg>
    )
  };

  return (
    <div className="flex items-center justify-center w-full h-full">
      {icons[type] || icons.autre}
    </div>
  );
};

export default VehicleIcon;
